export default __webpack_public_path__ + "static/media/test7.8c85eba3.png";